<span [id]="category().id">{{category().name()}}</span>
